import { render } from "./MonedaList.vue?vue&type=template&id=fff25580"
import script from "./MonedaList.vue?vue&type=script&lang=js"
export * from "./MonedaList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__